import t from"./_Uint8Array.js";function r(r){var e=new r.constructor(r.byteLength);return new t(e).set(new t(r)),e}export{r as default};
//# sourceMappingURL=_cloneArrayBuffer.js.map
